/**
 * @generated SignedSource<<9827b427c5b82252ae615302335ba995>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "key"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "key"
      }
    ],
    "concreteType": "Cache",
    "kind": "LinkedField",
    "name": "cache",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "date",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "QCacheQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "QCacheQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "293328b46def3c6b95803ee00c985f3f",
    "id": null,
    "metadata": {},
    "name": "QCacheQuery",
    "operationKind": "query",
    "text": "query QCacheQuery(\n  $key: String!\n) {\n  cache(key: $key) {\n    key\n    date\n  }\n}\n"
  }
};
})();

node.hash = "17e7393591c8261b9107cf81c250646e";

export default node;
